export default [
  {
    title: 'Tableau de bord',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    header: 'Commissions',
  },
  {
    title: 'Mes Factures',
    route: 'sales-invoices',
    icon: 'FileTextIcon',
  },
  {
    title: 'Mes Expéditeurs',
    route: 'sales-suppliers',
    icon: 'UsersIcon',
  },
  {
    header: 'Reporting',
  },
  {
    title: 'Reporting',
    icon: 'BarChart2Icon',
    children: [
      {
        title: 'Suivi par Gouvernorat',
        route: 'reporting-states',
      },
    ],
  },
  {
    header: 'Colis',
  },
  {
    title: 'Liste des colis',
    route: 'orders-index',
  },
  {
    title: 'Expéditeur',
    route: 'supplier-list',
  },
]
